module.exports = __webpack_public_path__ + "img/banner-sm-04.465d8f50.jpg";